/* eslint-disable max-classes-per-file */
import { BaseError } from 'make-error'
import * as R from 'ramda'

import { isPuiIdentifier } from './index'

export class ApiError extends BaseError {
  public response: any

  public arguments: any

  public responseBody: any

  public fingerprint: any[]

  public status: number

  public originalMessage: string

  public duration: number

  public method: any

  public payload: any

  public url: string

  constructor(cause: any, payload: any) {
    const { config = {}, response = {}, message } = cause || {}
    const {
      url: rawUrl = 'unknown url',
      method,
      params,
      metadata = {},
    } = config
    const { status, data } = response
    const urlSteps = rawUrl
      .split('/')
      .filter(Boolean)
      .map((string: string) => (isPuiIdentifier(string) ? '[ID]' : string))

    const url = urlSteps.join('/')
    const extendedMessage = status
      ? `${method} ${url} results with ${status}`
      : navigator.onLine
        ? `${method} ${url} results with ${message}`
        : `User tried to access ${method} ${url} while being offline`
    const name = `ApiError: ${extendedMessage}`

    super(data?.description || '')
    this.response = R.omit(['request'], response)
    this.arguments = params
    this.responseBody = data
    this.fingerprint = [name, method, ...urlSteps, status]
    this.status = status
    this.originalMessage = message
    this.duration = metadata.duration
    this.method = method
    this.payload = payload
    this.url = url

    // @NOTE: workaround to preserve class name after bundling
    //        used when Sentry generates metadata for error event
    this.name = name
  }
}

export class GraphQLError extends BaseError {
  public responseBody: any

  public status: number

  public originalMessage: string

  public payload: any

  constructor(cause: any, documentNode: any, payload: any) {
    const { extensions = {}, message } = cause || {}
    const { status } = extensions

    const stringOperations = documentNode.definitions
      .filter((definition: any) => definition?.operation)
      .map(
        (definition: any) =>
          `${definition?.operation} ${definition?.name.value}`,
      )
      .join()

    const extendedMessage = status
      ? `${stringOperations} results with ${status}`
      : navigator.onLine
        ? `${stringOperations} results with ${message}`
        : `User tried to access ${stringOperations} while being offline`

    const name = `GraphQLError: ${extendedMessage}`

    super(message || '')
    this.responseBody = {
      ...extensions,
      error: extensions,
    }
    this.status = status
    this.originalMessage = message
    this.payload = payload

    // @NOTE: workaround to preserve class name after bundling
    //        used when Sentry generates metadata for error event
    this.name = name
  }
}
